import { gql } from '@apollo/client';
const UPDATE_WAREHOUSE_RELEASE_CANCEL = gql `
  mutation UpdateWarehouseReleaseCancel($warehouseReleaseNodeId: ID!) {
    cancelWarehouseRelease(warehouseReleaseNodeId: $warehouseReleaseNodeId) {
      warehouseRelease {
        id
      }
    }
  }
`;
export default UPDATE_WAREHOUSE_RELEASE_CANCEL;
